





















import Vue from 'vue';
import ErrorIcon from '../../../assets/img/notifications-error-invert.svg';
export default Vue.extend({
    components: { ErrorIcon },
    props: {
        maxlength: {
            type: Number,
            default: undefined,
        },
        hasIconLeft: {
            type: Boolean,
            default: false,
        },
        hasIconRight: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        required: {
            type: Boolean,
            default: false,
        },
        value: {
            type: String,
            default: '',
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        inputRef: {
            type: String,
            default: '',
        },
    },
});
